module.exports = __webpack_public_path__ + "img/ico_link.8e15ec2f.svg";